// removed by extract-text-webpack-plugin
module.exports = {"descriptionContainer":"styles__descriptionContainer___23vNW","resetButtonClass":"styles__resetButtonClass___1BRgI","quantityClass":"styles__quantityClass___3Q6-g","numberItemsClass":"styles__numberItemsClass___2ngn4","controlButtonContainer":"styles__controlButtonContainer___13094","controlButtonClass":"styles__controlButtonClass___2syiz"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/NewInterfaceOnline/components/StepModals/components/StepLevelCalls/styles.css
// module id = 2878
// module chunks = 0